import React, { FC } from 'react'

import { useParams } from 'react-router-dom'
import { useDebounce } from 'use-debounce'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useGetCampaignGenresQuery } from 'src/Redux/spotifyCampaignGenresApi'
import { DEBOUNCE_TIMER_300 } from 'src/Constants/constants'

import { useSelectedGenres } from './useSelectedGenres'
import { useSaveGenres } from './useSaveGenres'
import { SpotifyGenresModalButtons } from './SpotifyGenresModalButtons'
import { SpotifyGenresModalHeader } from './SpotifyGenresModalHeader'
import { SelectedGenresList } from './SpotifyGenresModalLists/SelectedGenresList'
import { SpotifyGenresSearchInput } from './SpotifyGenresSearchInput'
import { SpotifyGenresModalReadyToSelectLists } from './SpotifyGenresModalLists/SpotifyGenresModalReadyToSelectLists'
import { MaxSelectedGenresMessage } from './MaxSelectedGenresMessage'

const MAX_SELECTED_GENRES = 7
export const SpotifyGenresModalContent: FC = () => {
  const { setSearch } = useCustomSearchParams()
  const { number } = useParams<{ number: string }>()
  const { saveGenres, isLoading } = useSaveGenres()
  const { selectedGenres, onSetSelectedGenres } = useSelectedGenres()
  const { data } = useGetCampaignGenresQuery(number || '', {
    skip: !number,
  })
  const [searchValue, setSearchValue] = React.useState('')
  const [debouncedSearchValue] = useDebounce(searchValue, DEBOUNCE_TIMER_300)

  const hasMaxSelectedGenres = selectedGenres.length >= MAX_SELECTED_GENRES
  return (
    <>
      <SpotifyGenresModalHeader />

      <SpotifyGenresSearchInput
        disabled={hasMaxSelectedGenres}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <SelectedGenresList
        genres={selectedGenres}
        onClickGenre={onSetSelectedGenres}
      />
      {!hasMaxSelectedGenres && (
        <SpotifyGenresModalReadyToSelectLists
          debouncedSearchValue={debouncedSearchValue}
          selectedGenres={selectedGenres}
          data={data}
          onSetSelectedGenres={onSetSelectedGenres}
        />
      )}
      {hasMaxSelectedGenres && <MaxSelectedGenresMessage />}
      <SpotifyGenresModalButtons
        disabledAdd={selectedGenres.length === 0}
        loadingAdd={isLoading}
        onClickAddGenres={() => saveGenres(selectedGenres)}
        onClickGoBack={() => setSearch({ modal: null })}
      />
    </>
  )
}
